import React from 'react';

const NotificationsContext = React.createContext();
NotificationsContext.displayName = "NotificationsContext";

export default NotificationsContext;



// WEBPACK FOOTER //
// ./src/context/notificationsContext.js